"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'payment.validation.providerRequired': '支付提供商是必需的',
    'payment.validation.amountRequired': '有效金额是必需的',
    'payment.validation.currencyRequired': '货币是必需的',
};
